import React, { useEffect, useState, useRef } from 'react';
import { Box, Typography, Container, Paper, CircularProgress, Alert } from '@mui/material';
import { useSearchParams, Link } from 'react-router-dom';
import FetchService from '../../services/FetchService';
import endpoints from '../../environment/endpoints';

export default function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const isFetched = useRef(false);

  useEffect(() => {
    const fetchService = new FetchService();
    const userid = searchParams.get('userid');
    const token = searchParams.get('token');

    if (!userid || !token) {
      setStatus('error');
      setMessage('Invalid confirmation link.');
      return;
    }

    if (!isFetched.current) {
        isFetched.current = true;
        
        fetchService.post(endpoints.confirmEmail, { userId: userid, token })
        .then((res: any) => {
            if (res.success) {
                setStatus('success');
                setMessage('Your email has been successfully confirmed!');
            } else {
                setStatus('error');
                setMessage(res.data?.message || res.errors || 'There was an error confirming your email.');
            }
        })
        .catch(() => {
            setStatus('error');
            setMessage('Network error.');
        });
    }

  }, [searchParams]);

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h4" gutterBottom fontWeight="bold" color="secondary">
          Email Confirmation
        </Typography>

        {status === 'loading' && (
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <CircularProgress />
            <Typography sx={{ mt: 2 }}>Confirming your email...</Typography>
          </Box>
        )}

        {status === 'success' && (
          <Box sx={{ mt: 2, width: '100%', textAlign: 'center' }}>
            <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>
            <Typography variant="body1">
              You may now <Link to="/login" style={{ color: '#FF3900', fontWeight: 'bold' }}>Login</Link> to your account.
            </Typography>
          </Box>
        )}

        {status === 'error' && (
          <Box sx={{ mt: 2, width: '100%', textAlign: 'center' }}>
             <Alert severity="error">{message}</Alert>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
